query ApprovalHistorySearchHints(
  $searchRequest: SearchRequestInput!
  $filterApprovalId: UUID
  $isQueuedSearch: Boolean
  $isHistorySearch: Boolean
  $approverUserId: UUID
  $isApproverUserApprover: Boolean
  $isApproverUserRequester: Boolean
  $isOnlyUnsignedApprovals: Boolean
  $isLinkSearch: Boolean
) {
  approvalHistorySearchHints(
    searchRequest: $searchRequest
    filterApprovalId: $filterApprovalId
    isQueuedSearch: $isQueuedSearch
    isHistorySearch: $isHistorySearch
    approverUserId: $approverUserId
    isApproverUserApprover: $isApproverUserApprover
    isApproverUserRequester: $isApproverUserRequester
    isOnlyUnsignedApprovals: $isOnlyUnsignedApprovals
    isLinkSearch: $isLinkSearch
  ) {
    nodes {
      id
      caption
      resultsCount
    }
  }
}
